// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:44:30+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            6cee10ce22bf873d19c678ce122a11e8
//    Signature:      eyJpdiI6IkdlM2J1VVpXanVnR1FYYnNKaWZBNVE9PSIsInZhbHVlIjoiK05wVHhjYmRIUkUyMHNkZUpteFwvcGlLNWpoWFo2Nzh5dXVKanQyeTAyTDFUNUFYakxqR1BcLzVrZDZ4enpqOUdvVEduUXhVZXJTRjljQ0NjbjRpOUJ0YkptR0tDdWsxY2RLOU9DZzdxSXg2Y0tJRXIyZ0xQUVRQRFwvVmN2NW9NS0RIM1pFd2EyYjBRYStwMll5alhrWEQ0SFphbGljMHNnNTB6cUgrTkNnNUNuUnJ4YjhzcTVoSWdsSDdGY1V5YWFSNGlLbVk4ZFJRR1FuK1pEbXIxdTkxOVJHMVEwUFFmS2g1cjM5NzdUdWt6cjEzUXlpVUJwZHBkXC9RalN4eWlTRWtjMGU1eG1TNDM4XC9vS21xWTIrRzR5cE9XRDZsRE1nbllhMk1EdklYbUFNWU9TSXNUOEVvdjRkOXp4Snk0T0dqYm1xV0xvc2NCR3Y0enF6dFVMMHVyMDdueDdTcjBZUjA0NEQ3MlZrZWpHeGJ0bW9IeXpOUVNldVFwSzliYUF0VlVkZnBuWDNuOHlFbVZFbVpoTHRpUzVBPT0iLCJtYWMiOiIyYzczYWY3Yzc5OWE0ZjNlMGY2NjBjN2QwYzA5ZGMwZDNmY2ZhZWI0Mjk1ODljNDY0NmRiOTRiZGYwZTU4OTY3In0=
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
